export default function () {
  const widgetName = 'staticManagedSponsors';
  const widgetOpts = staticManagedSponsorsOpts;
  const $widget = $(`#${widgetName}`);

  const wrapContainerClass = 'sponsors-wrap-container';

  const enableHeading = true;
  const headingTag = 'h2';
  const headingTitle = 'Major Sponsors';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 6,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (!hasData) {
        $(`.${wrapContainerClass}`).remove();
        $widget.remove();
      } else {
        customTitleFeature();
        createCustomCards(data.items);
      }
    },
  });

  // *********************************************************
  // Function Helper
  function createCustomCards(widgetData) {
    $widget.find('.card-widget-item').each(function (x) {
      const $sponsor = $(this);
      const { Title, URL } = widgetData[x];

      $sponsor.find('.card-content').remove();
      $sponsor.attr('title', Title);

      if (URL == null) {
        $sponsor.removeAttr('href');
      }
    });
  }

  function customTitleFeature() {
    if (enableHeading) {
      $(`.${wrapContainerClass} .inner-container`).prepend(
        `<${headingTag} class="static-sponsors-title">${headingTitle}</${headingTag}>`,
      );
    }
  }
}
